import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import FormattedDateTextInput from './FormattedDateTextInput';
import JobInputTitle from './JobInputTitle';
import {convertDate} from '../shared/functions';

class JobDateInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedDate: null,
            selectedDateObject: null
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.reset && !this.props.reset) {
            this.setState({
                selectedDate: null,
                selectedDateObject: null,
            });
        }
    }

    // Event: Handle Date selection and notify form
    handleDateSelect = (event, index, value) => {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            // Date native types are "str" so far
            let dateValue = (this.props.nativeType === 'str') ? dateStr : dateStr;
            this.setState({
                    selectedDate: dateStr,
                    selectedDateObject: index,
                }, () => {
                    if (typeof this.props.onSelectDate === 'function') {
                        this.props.onSelectDate(this.props.customType, this.props.name, dateValue);
                    }
                }
            );
        }
    };

    render() {
        const {
            label,
            name,
            required,
            tooltip
        } = this.props;

        return (
            <Fragment>
                <JobInputTitle label={label} tooltip={tooltip}/>
                <FormattedDateTextInput
                    source={name}
                    name={name}
                    label={(required) ? label + ' *' : label}
                    isRequired={required}
                    onChangeFunc={this.handleDateSelect}
                />
            </Fragment>
        )
    }
}

JobDateInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onSelectDate: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    reset: PropTypes.bool,
    tooltip: PropTypes.string
};

JobDateInput.defaultProps = {
    defaultValue: '',
    name: 'date',
    param: 'date',
    nativeType: 'str',
    required: false,
    reset: false
};

export default JobDateInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobDateInput.js